<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model
        :form="form"
        :model="model"
        :rules="validatorRules"
        @keyup.enter.native="submitForm"
        ref="form"
        slot="detail"
      >
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备名称" prop="devName">
              <a-input :disabled="colDisabled.includes('devName')" placeholder="请输入设备名称" v-model="model.devName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备类型" prop="devClassCode">
              <j-tree-select-custom
                @change="handleModeQuery"
                column="dev_class_code"
                dict="`iwt-wf`.dev_class,type_name,id"
                hasChildField="has_child"
                order="sort_no asc"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                returnKey="dev_class_code"
                v-model="model.devClassCode"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备型号" prop="devTypeId">
              <a-row>
                <a-col :span="17" class="pr-8px">
                  <a-select
                    :default-active-first-option="false"
                    @change="modelChange"
                    allowClear
                    defaultActiveFirstOption
                    placeholder="请选择设备型号"
                    show-search
                    v-model="model.devTypeId"
                  >
                    <a-select-option :key="d.id" v-for="d in devModelList">{{ d.modelName }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-button @click="handleModalAdd" class="ml-8px" icon="plus" type="primary">新增</a-button>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" disabled label="设备身份编号" prop="devCode">
              <a-input placeholder="请输入设备身份编号" v-model="model.devCode"></a-input>
            </a-form-model-item>
          </a-col>-->

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" disabled label="表号" prop="devTag">
              <a-input placeholder="请输入表号" v-model="model.devTag"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="安装位置" prop="location">
              <a-input v-model="model.location">
                <a-icon @click="mapLocate" slot="addonAfter" type="setting" />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="省市区" prop="region">
              <j-area-linkage placeholder="请选择省市区" type="cascader" v-model="model.region" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="腾讯(高德)坐标" prop="coordinateGcj02">
              <a-input placeholder="腾讯(高德)坐标【经度,维度】，例如113.953816,22.891788" v-model="model.coordinateGcj02"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="GPS坐标" prop="coordinateWgs84">
              <a-input placeholder="GPS坐标【经度,维度】，例如113.953816,22.891788" v-model="model.coordinateWgs84"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供水流域" prop="devProcessId">
              <!-- <j-dict-select-tag
                :disabled="colDisabled.includes('devProcessId')"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="model.devProcessId"
              /> -->
              <j-dict-select-tag
                dictCode="`iwt-wf`.dev_area_location,area_name,id"
                placeholder="请选择供水流域"
                v-model="model.areaId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备照片" prop="pictureObjId">
              <j-image-upload :disabled="disabled" bizPath="dev/pic" isMultiple v-model="model.pictureObjId"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人" prop="leaderId">
              <j-dict-select-tag
                :dictCode="
                  `sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get(
                    'TENANT_ID'
                  )}' order by realname`
                "
                pageSize="100"
                placeholder="请选择负责人"
                type="list"
                v-model="model.leaderId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="出厂日期" prop="factoryDate">
              <j-date placeholder="请选择出厂日期" style="width: 100%" v-model="model.factoryDate" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="出厂编号" prop="factoryNumber">
              <a-input placeholder="请输入出厂编号" v-model="model.factoryNumber"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- operationDate -->

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投运状态" prop="serviceStatus">
              <j-dict-select-tag
                :disabled="colDisabled.includes('serviceStatus')"
                dictCode="dev_life_status"
                type="radioButton"
                v-model="model.serviceStatus"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投运日期" prop="operationDate">
              <j-date placeholder="请选择投运日期" style="width: 100%" v-model="model.operationDate" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <dev-model-modal @ok="modalFormOk" ref="modalForm"></dev-model-modal>
    </j-form-container>

    <t-map-point-picker
      :default-center="[116.40, 39.90]"
      :default-zoom="12"
      @change="locationChange"
      ref="pointPicker"
    />
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import DevModelModal from '@/views/equipment/account/vue/modules/DevModelModal'

  import TMapPointPicker from '@/components/map/TMapPointPicker'
  import coordTransform from '@/utils/coordTransform';

  export default {
    name: 'DevListForm',
    components: {
      DevModelModal,
      TMapPointPicker
    },
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      disabledCols: {
        type: Array,
        default: [],
        required: false
      }
    },
    data () {
      return {
        devTypeShow: true,
        devModelList: [],
        classParams: {
          id: "'admin'"
        },
        form: this.$form.createForm(this),
        model: {
          serviceStatus: 'operation',
          importance: '1',
          devCode: '',
          devTypeId: null
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        validatorRules: {
          devName: [{ required: true, message: '请输入设备名称!' }],
          devClassCode: [{ required: true, message: '请选择设备类型!' }]
        },
        areaList: [],
        url: {
          add: '/device/devList/add',
          edit: '/device/devList/edit',
          queryById: '/device/devList/queryById',
          //modelListUrl: '/device/devModel/queryByDevClassId'  //`/device/devModel/list?devClassId=`${model.devClassId}
          modelListUrl: '/device/devModel/list',
          retire: '/device/devList/devScrapReplace'
        },
        settings: {
          name: '区域选择',
          displayKey: 'areaName',
          valueKey: 'id',
          returnKeys: ['id', 'areaName'],
          queryParamCode: 'areaName',
          queryParamText: '区域名称',
          listUrl: '/device/devAreaLocation/list',
          columns: [
            { title: '区域名称', dataIndex: 'areaName', align: 'center', width: '30%', widthRight: '70%' },
            {
              title: '说明',
              align: 'center',
              dataIndex: 'description'
            }
          ],
          devModelList: []
        },
        modelSettings: {
          name: '设备型号',
          displayKey: 'modelName',
          valueKey: 'id',
          returnKeys: ['id', 'modelName'],
          listUrl: '/device/devModel/list',
          queryParamCode: 'modelName',
          queryParamText: '设备型号',
          columns: [
            { title: '型号名称', dataIndex: 'modelName', align: 'center', width: '30%', widthRight: '70%' },
            // devCode

            {
              title: '型号编码',
              align: 'center',
              dataIndex: 'modelCode'
            },
            {
              title: '运行寿命',
              align: 'center',
              dataIndex: 'runningLife'
            }
          ]
        },
        modelLoad: false
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      colDisabled () {
        return this.disabledCols
      }
    },
    created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify({ ...this.model }))
    },

    methods: {
      mapLocate () {
        let point = null;
        if (this.model.coordinateWgs84) {
          point = this.model.coordinateWgs84.split(',').map(Number);
        } else if (this.model.coordinateGcj02) {
          const gcj02 = this.model.coordinateGcj02.split(',').map(Number);
          point = coordTransform.gcj02ToWgs84(gcj02[0], gcj02[1]);
        }
        this.$refs.pointPicker.open({
          point,
          address: this.model.location
        });
      },
      locationChange (data) {
        if (!data) {
          return;
        }
        this.model = { ...this.model, location: data.address, coordinateGcj02: data.coordinateGcj02.join(','), coordinateWgs84: data.coordinateWgs84.join(','), region: data.region };
      },
      modelChange (v) {
        if (v === undefined) this.model.devTypeId = ''
      },
      modalFormOk ({ id = '', modelName = '' }) {
        // this.$emit('modeAddEnd', id)
        // this.$refs.bizModal.visible = false
        this.devModelList.push({
          id,
          modelName
        })
        this.model.devTypeId = id
      },
      handleModalAdd: function () {
        this.$refs.modalForm.add()
        this.$refs.modalForm.title = '新增'
        this.$refs.modalForm.disableSubmit = false
      },
      async handleModeQuery (v) {
        if (this.model.devTypeId) this.model.devTypeId = ''
        this.devModelList = []
        const { success, result } = await getAction('/device/devModel/queryByDevClassId', {
          devClassCode: v
        })
        if (success) {
          this.devModelList = result
        }
      },
      modeAddEnd (id) {
        this.devTypeShow = false
        this.model.devTypeId = id
        this.devTypeShow = true
        this.modelSettings.listUrl = `/device/devModel/list?devClassId=${this.model.devClassId ?? ''}&t=${Math.random()}`
      },
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        if (!record.id) {
          record.operationDate = this.$moment().format('YYYY-MM-DD')
          record.serviceStatus = 1
        }
        if (record.id) {
          this.handleModeQuery(record.devClassCode)
        }
        this.model = Object.assign({}, record)
        this.classParams.id = record.devClassCode

        this.visible = true
      },
      submitForm (type) {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl = this.url.add
              method = 'post'
            } else {
              httpurl = this.url.edit
              method = 'put'
            }
            if (type === 'retire') {
              httpurl = this.url.retire
              method = 'post'
            }
            httpAction(httpurl, this.model, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      },
      getFormFieldValue (field) {
        return this.form.getFieldValue(field)
      },
      popupCallback (v, row) {
        this.model.type_name = v

        this.model.devClassId = row.id
      }
    }
  }
</script>
